import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Field as AvField, Form as AvForm } from "@availity/form"
import { Button, FormGroup, Label } from "reactstrap"
import * as yup from "yup"

import { useWallet } from "../../libs/useMetaMaskWallet"
import subdomains from "../../constants/subdomains.json"
import { contracts } from "../../Pages/NFTSale/utils"
import { networkIcons } from "../../utils"
import ConfirmSubmitModal from "../ConfirmSubmitModal/ConfirmSubmitModal"
import CustomTooltip from "../Tooltip"
import "./LootBoxCard.scss"

import { approveSpender, buyBox, preOpenBox, openBox, lootBoxType } from "../../Pages/NFTSale/utils"

const LootBoxCard = ({ lootbox, idx, subdomain, allowance, balance, enableClickLootbox = true, lootBoxIsPurchased = false, contractType }) => {
    // if purchased == true lootbox has ben purchased, if false lootbox is available for purchase
    const wallet = useWallet()

    const collectionAddress = contracts[subdomain]?.[contractType]?.address
    const chain = contracts[subdomain]?.network
    const contractOwner = contracts[subdomain]?.[contractType]?.owner
    const collectionSymbol = contracts[subdomain]?.[contractType]?.symbol

    const [showImageLoading, setShowImageLoading] = useState(true)
    const [quantity, setQuantity] = useState(0) // quantity of lootbox nft to purchase
    const [showBtnSpinner, setShowBtnSpinner] = useState(false) // loading animation on approve/purchase button
    const [lootboxIsClickable, setLootboxIsClickable] = useState(enableClickLootbox) // if true, clicking lootboxcard loads lootboxDetail page
    const [showConfirmSubmitModal, setShowConfirmSubmitModal] = useState(false) // when user clicks on "approve" or "purchase", this modal shows
    const [modalAlertMessage, setModalAlertMessage] = useState("")
    const [alertColor, setAlertColor] = useState("")
    const [disableModalButtons, setDisableModalButtons] = useState(false)
    const [showConfirmLoading, setShowConfirmLoading] = useState(false)

    const [buyTx, setBuyTx] = useState(null)
    const [openTx, setOpenTx] = useState(null) // tx hash
    const [preOpenTx, setPreOpenTx] = useState(null) // tx hash

    // console.log("lootbox card", lootbox)
    console.log("buyTx, openTx, preOpenTx", buyTx, openTx, preOpenTx)

    const confirmApprovePurchase = async (type) => {
        console.log(type)
        setShowConfirmLoading(true)
        setDisableModalButtons(true)

        switch (type) {
            case "APPROVE":
                console.log("Call Approve")
                const approveTx = approveSpender(wallet, setDisableModalButtons, setShowConfirmLoading)
                break
            case "PURCHASE":
                console.log("Call Purchase")
                const buyTx = buyBox(wallet, lootbox?.name, quantity, setDisableModalButtons, setShowConfirmLoading, setBuyTx)
                break
            case "CLOSE":
                setShowConfirmSubmitModal(false)
                setBuyTx(null)
                setOpenTx(null)
                setPreOpenTx(null)
                break
            case "PREOPEN":
                console.log("Call PreOpen")
                const preOpenTx = preOpenBox(wallet, lootbox?.boxId, setDisableModalButtons, setShowConfirmLoading, setPreOpenTx)
                break
            case "OPEN":
                console.log("Call Open")
                const openTx = openBox(wallet, lootbox?.boxId, setDisableModalButtons, setShowConfirmLoading, setOpenTx)
                break

            default:
                setShowConfirmLoading(false)
                setDisableModalButtons(false)
                break
        }
    }

    const handleClickLootBoxCard = (e) => {
        // console.log("e?.target?.lastChild?.innerHTML", e?.target?.lastChild?.innerHTML)
        // console.log("e?.target?.innerHTML", e?.target?.innerHTML)
        // console.log("e?.target?.lastChild?.localName", e?.target?.lastChild?.localName)

        const buttonTxt = e?.target?.lastChild?.innerHTML

        // if user clicks input quantity form
        if (e?.target?.localName === "input") e.preventDefault() // prevent redirect to lootboxDetails page

        if (buttonTxt === "INSUFFICIENT BALANCE") e.preventDefault()

        // clicking "approve" or "purchase" button
        if (e?.target?.innerHTML === "APPROVE" || e?.target?.innerHTML === "PURCHASE" || buttonTxt === "APPROVE" || buttonTxt === "PURCHASE") {
            e.preventDefault()
            // check if quantity is valid integer
            if (Number(quantity) > 0 && Number.isInteger(Number(quantity))) setShowConfirmSubmitModal(true)
        }

        // user clicks "OPEN" or "PRE OPEN" button
        if (e?.target?.innerHTML === "OPEN" || buttonTxt === "OPEN") {
            e.preventDefault()

            // don't show open box modal if lootbox not preopened AND preopening transaction hasn't finalized
            if (!lootbox?.preOpened && Number(lootbox?.requestId) > 0) return
            setShowConfirmSubmitModal(true)
        }
    }

    return (
        <React.Fragment>
            {/* if lootbox is for sale, render lootbox for sale component */}
            {!lootBoxIsPurchased ? (
                // if user clicks this component & lootboxIsClickable, render the LootBoxDetail component (and use "fake" nested route '/nftsale/:lootbox_id')
                <Link
                    className={"loot-box-card-link" + (lootboxIsClickable ? " show-background" : "")}
                    to={{
                        pathname: `/nftsale/${lootbox?.id}`,
                        state: {
                            lootbox,
                            subdomain,
                            idx,
                            allowance,
                            balance,
                            enableClickLootbox: false,
                            lootBoxIsPurchased,
                            collectionAddress,
                            chain,
                            collectionSymbol
                        }
                    }}
                    onClick={handleClickLootBoxCard}
                >
                    <div className="loot-box-card">
                        <div className={"image-wrap"}>
                            {/* TO DO: (low priority)- show loading animation only for nft lootbox image */}
                            {/* {showImageLoading && (token.tokenURI || token.uri) && (
                                <div className="image-loading-wrap">
                                    <img src={blankLoadingPic} alt="loading" />
                                    <Spinner className="image-loading" />
                                </div>
                            )} */}

                            {subdomain === "swordsofblood" && (
                                <img
                                    src={lootbox?.imgUrl}
                                    onLoad={() => setShowImageLoading(false)}
                                    alt={subdomain + " lootbox"}
                                    className={"lootbox-img" + (showImageLoading ? " hide" : "")}
                                />
                            )}
                        </div>

                        {/* <div className="lootbox-chain-wrap">
                            <img src={networkIcons["polygon"]} alt={"polygon"} />
                            <span>{"polygon"}</span>
                            </div> */}
                        {/* </div> */}

                        <AvForm
                            className="purchase-form-wrap"
                            enableReinitialize
                            // NOTE* initialValue key's must match "name" attribute value in AvField components!
                            initialValues={{ quantity: quantity }}
                            validationSchema={yup.object().shape({
                                quantity: yup
                                    .number()
                                    .required("This field is required.")
                                    // if callback in .test returns false, show error message
                                    .test("valid quantity?", "Must be a positive integer", (num) => Number.isInteger(num) && Number(num) > 0)
                            })}
                        >
                            <div className="lootbox-name">{lootbox?.name}</div>

                            <div className="lootbox-cost">
                                <span className="lootboxcard-label-title">COST:</span>
                                <span className="lootboxcard-label-value">
                                    $ {lootbox?.cost} {balance?.symbol}
                                </span>
                            </div>

                            <FormGroup className="mb-3">
                                <AvField
                                    name="quantity"
                                    label="Quantity"
                                    placeholder="Enter Number"
                                    type="number"
                                    className="form-control"
                                    disabled={showBtnSpinner}
                                    min={0}
                                    onChange={(e) => setQuantity(e.target.value)}
                                    onMouseEnter={() => setLootboxIsClickable(false)}
                                    onMouseLeave={() => {
                                        if (enableClickLootbox) setLootboxIsClickable(true)
                                    }}
                                />
                            </FormGroup>

                            <div className="lootbox-total-cost">
                                <span className="lootboxcard-label-title">TOTAL:</span>
                                <span className="lootboxcard-label-value">
                                    $ {Number(lootbox?.cost) * quantity} {balance?.symbol}
                                </span>
                            </div>

                            <Button
                                color="primary"
                                type="submit"
                                disabled={quantity < 1 || Number(lootbox?.cost * quantity) > Number(balance?.balance)}
                                className="approve-purchase-btn"
                                onMouseEnter={() => setLootboxIsClickable(false)}
                                onMouseLeave={() => {
                                    if (enableClickLootbox) setLootboxIsClickable(true)
                                }}
                            >
                                {Number(lootbox?.cost * quantity) > Number(balance?.balance)
                                    ? "INSUFFICIENT BALANCE"
                                    : Number(lootbox?.cost * quantity) > Number(allowance)
                                      ? `APPROVE`
                                      : `PURCHASE`}
                            </Button>
                        </AvForm>
                    </div>

                    {/* CONFIRM APPROVE or PURCHASE MODAL */}
                    {showConfirmSubmitModal && (
                        <ConfirmSubmitModal
                            showConfirmSubmitModal={true}
                            setShowConfirmSubmitModal={setShowConfirmSubmitModal}
                            modalAlertMessage={modalAlertMessage}
                            setModalAlertMessage={setModalAlertMessage}
                            alertColor={alertColor}
                            setAlertColor={setAlertColor}
                            disableAllButtons={disableModalButtons}
                            showConfirmLoading={showConfirmLoading}
                            handleClickConfirm={
                                buyTx
                                    ? () => confirmApprovePurchase("CLOSE")
                                    : Number(lootbox?.cost * quantity) > Number(balance?.balance)
                                      ? "INSUFFICIENT BALANCE"
                                      : Number(lootbox?.cost * quantity) > Number(allowance)
                                        ? () => confirmApprovePurchase("APPROVE")
                                        : () => confirmApprovePurchase("PURCHASE")
                            }
                            modalTitle={Number(lootbox?.cost * quantity) > Number(allowance) ? "Confirm Lootbox Approval" : "Purchase Lootbox"}
                            confirmButtonText={
                                buyTx
                                    ? "CLOSE"
                                    : Number(lootbox?.cost * quantity) > Number(balance?.balance)
                                      ? "INSUFFICIENT BALANCE"
                                      : Number(lootbox?.cost * quantity) > Number(allowance)
                                        ? `APPROVE`
                                        : `PURCHASE`
                            }
                            confirmButtonLoading={Number(lootbox?.cost * quantity) > Number(allowance) ? "APPROVING" : `PURCHASING`}
                        >
                            {!buyTx && Number(lootbox?.cost * quantity) > Number(allowance) && (
                                <div className="clicking-approve-txt">
                                    Clicking approve calls a method on the currency contract to allow the sale contract to spend your wallet funds
                                </div>
                            )}

                            <div className="modal-lootbox-name">
                                <span className="modal-label">Loot Box Name:</span> {lootbox?.name}
                            </div>
                            <div className="modal-lootbox-cost">
                                <span className="modal-label">Cost:</span> $ {lootbox?.cost} {balance?.symbol}
                            </div>
                            <div className="modal-lootbox-quantity">
                                <span className="modal-label">Quantity:</span> {quantity}
                            </div>
                            <div className="modal-lootbox-total">
                                <span className="modal-label">Total:</span> $ {Number(lootbox?.cost) * quantity} {balance?.symbol}
                            </div>
                            <img src={lootbox?.imgUrl} alt={subdomain + " lootbox"} className="lootbox-img-modal" />
                            {buyTx && (
                                <div className="tx-hash">
                                    <span className="modal-label">Purchase Tx Hash: </span>
                                    <span className="tx-hash-val">{buyTx}</span>
                                </div>
                            )}
                        </ConfirmSubmitModal>
                    )}
                </Link>
            ) : (
                // ------------------------------------------------------------------------------
                // PURCHASED/OPENED LOOTBOX COMPONENT
                // if Loot Box has been purchased/opened, render purchased lootbox component
                <Link
                    className={"loot-box-card-link" + (lootboxIsClickable ? " show-background" : "")}
                    to={{
                        pathname: `/nftsale/${lootbox?.id}`,
                        state: {
                            lootbox,
                            subdomain,
                            idx,
                            allowance,
                            balance,
                            enableClickLootbox: false,
                            lootBoxIsPurchased: true,
                            lootBoxIsPreOpened: lootbox?.preOpened,
                            collectionAddress,
                            chain,
                            contractOwner,
                            collectionSymbol
                        }
                    }}
                    onClick={handleClickLootBoxCard}
                >
                    <div className="loot-box-card purchased">
                        <div className={"image-wrap"}>
                            {/* TO DO: (low priority)- show loading animation only for nft lootbox image */}
                            {/* {showImageLoading && (token.tokenURI || token.uri) && (
                            <div className="image-loading-wrap">
                                <img src={blankLoadingPic} alt="loading" />
                                <Spinner className="image-loading" />
                            </div>
                        )} */}

                            {subdomain === "swordsofblood" && (
                                <img
                                    src={lootbox?.imgUrl}
                                    onLoad={() => setShowImageLoading(false)}
                                    alt={subdomain + " lootbox"}
                                    className={"lootbox-img" + (showImageLoading ? " hide" : "")}
                                />
                            )}
                        </div>

                        {/* <div className="lootbox-chain-wrap">
                        <img src={networkIcons["polygon"]} alt={"polygon"} />
                        <span>{"polygon"}</span>
                        </div> */}
                        {/* </div> */}

                        <div className="lootbox-name">{lootbox?.name}</div>
                        <div className="lootbox-id">BoxId: {lootbox?.boxId}</div>

                        {lootbox?.opened ? (
                            <div className="opened-lootbox">OPENED</div>
                        ) : (
                            <CustomTooltip
                                className="preopen-pending-tooltip"
                                title={
                                    !lootbox?.preOpened && Number(lootbox?.requestId) > 0
                                        ? "Please wait until the pre open transaction has finalized"
                                        : ""
                                }
                                placement="bottom"
                            >
                                <Button
                                    color="primary"
                                    type="submit"
                                    disabled={lootbox?.opened}
                                    className={"approve-purchase-btn" + (!lootbox?.preOpened && Number(lootbox?.requestId) > 0 ? " disable-btn" : "")}
                                    onMouseEnter={() => setLootboxIsClickable(false)}
                                    onMouseLeave={() => {
                                        if (enableClickLootbox) setLootboxIsClickable(true)
                                    }}
                                >
                                    OPEN
                                </Button>
                            </CustomTooltip>
                        )}
                    </div>

                    {/* OPEN LOOTBOX MODAL */}
                    {showConfirmSubmitModal && (
                        <ConfirmSubmitModal
                            showConfirmSubmitModal={true}
                            setShowConfirmSubmitModal={setShowConfirmSubmitModal}
                            modalAlertMessage={modalAlertMessage}
                            setModalAlertMessage={setModalAlertMessage}
                            alertColor={alertColor}
                            setAlertColor={setAlertColor}
                            disableAllButtons={disableModalButtons}
                            showConfirmLoading={showConfirmLoading}
                            className="confirm-open"
                            handleClickConfirm={
                                openTx || preOpenTx
                                    ? () => confirmApprovePurchase("CLOSE")
                                    : !lootbox?.preOpened
                                      ? () => confirmApprovePurchase("PREOPEN")
                                      : () => confirmApprovePurchase("OPEN")
                            }
                            modalTitle={"Open Loot Box"}
                            confirmButtonText={openTx ? "CLOSE" : !lootbox?.preOpened ? "PRE OPEN" : "OPEN"}
                            confirmButtonLoading={!lootbox?.preOpened ? "PRE OPENING" : "OPENING"}
                        >
                            {!lootbox?.preOpened && (
                                <div className="modal-lootbox-open-txt">
                                    Pre Opening a Loot Box calls a method on the Loot Box Sale Contract to allow you to open the box. Once a box is
                                    pre opened, you can open it to mint all the NFTs
                                </div>
                            )}

                            <div className="modal-lootbox-open-description">
                                {subdomains[subdomain]?.lootboxDetails?.[lootBoxType[lootbox?.name]]}
                            </div>

                            <div className="open-modal-lootbox-name">
                                <span className="modal-label">Loot Box Name:</span> {lootbox?.name}
                            </div>

                            <img src={lootbox?.imgUrl} alt={subdomain + " lootbox"} className="lootbox-img-modal" />

                            {(openTx || preOpenTx) && (
                                <div className="tx-hash">
                                    <span className="modal-label">Open Tx Hash: </span>
                                    <span className="tx-hash-val">{openTx}</span>
                                </div>
                            )}
                        </ConfirmSubmitModal>
                    )}
                </Link>
            )}
        </React.Fragment>
    )
}

export default LootBoxCard
